import { appCloseModal } from "../../store/actions/appAction";
import { useDispatch } from "react-redux";
import AddAccountModal from "../Shared/Modals/AddAccountModal";
import { styled } from "@mui/system";
import { BoxUpper } from "components/Shared/BoxUpper";
import CloseIcon from "assets/icons/CloseIcon";
import { IconButton } from "@mui/material";
import AddWidgetModal from "components/Shared/Modals/AddWidgetModal";
import Form from "../Form";
import AddAccountTypeModal from "components/Shared/Modals/AddAccountTypeModal";
import ChangePasswordModal from "components/Shared/Modals/ChangePasswordModal";
import ImportExcelModal from "components/Shared/Modals/ImportExcelModal";

import { AiOutlineClose } from "react-icons/ai";
import ShowSystemNotification from "components/Shared/Modals/ShowSystemNotification";

export default function Modal(props) {
  const { show, modalProps } = props;
  const defaultModalProps = {
    component: null,
    title: null,
    closeButton: null,
  };

  return (
    <ModalContainer show={show} modalProps={modalProps ?? defaultModalProps}>
      {show ? (
        RenderModalComponent(modalProps ?? defaultModalProps)
      ) : (
        <div className="col-lg-12 placeholder-glow" aria-hidden="true">
          <span className="placeholder mt-4 bg-secondary col-12 placeholder-lg" />
          <span className="placeholder mt-4 bg-secondary col-12 placeholder-lg" />
          <span className="placeholder mt-4 bg-secondary col-5 offset-2" />
          <span className="placeholder mt-4 bg-secondary col-5" />
          <span className="placeholder mt-4 bg-secondary col-5 offset-2 placeholder-lg" />
          <span className="placeholder mt-4 bg-secondary col-5 placeholder-lg" />
          <span className="placeholder mt-4 bg-secondary col-5 offset-2" />
          <span className="placeholder mt-4 bg-secondary col-5" />
          <span className="placeholder mt-4 bg-secondary col-5 offset-2 placeholder-lg" />
          <span className="placeholder mt-4 bg-secondary col-5 placeholder-lg" />
          <span className="placeholder mt-4 bg-secondary col-5 offset-2" />
          <span className="placeholder mt-4 bg-secondary col-5" />
          <span className="placeholder mt-4 bg-secondary col-5 offset-2 placeholder-lg" />
          <span className="placeholder mt-4 bg-secondary col-5 placeholder-lg" />
          <span className="placeholder mt-4 bg-secondary col-5 offset-2" />
          <span className="placeholder mt-4 bg-secondary col-5" />
          <span className="placeholder mt-4 bg-secondary col-5 offset-2 placeholder-lg" />
          <span className="placeholder mt-4 bg-secondary col-5 placeholder-lg" />
        </div>
      )}
    </ModalContainer>
  );
}

const RenderModalComponent = (modalProps) => {
  switch (modalProps.component) {
    case "person":
      return <Form type={"person"} modal={true} modalProps={modalProps} />;
    case "product":
      return <Form type={"product"} modal={true} modalProps={modalProps} />;
    case "financial":
      return <Form type={"financial"} modal={true} modalProps={modalProps} />;
    case "project":
      return <Form type={"project"} modal={true} modalProps={modalProps} />;
    case "branch":
      return <Form type={"branch"} modal={true} modalProps={modalProps} />;
    case "inventory":
      return <Form type={"inventory"} modal={true} modalProps={modalProps} />;
    case "change-password":
      return <ChangePasswordModal {...modalProps} />;
    case "add-account":
      return <AddAccountModal {...modalProps} />;
    case "add-widget":
      return <AddWidgetModal {...modalProps} />;
    case "add-account-type":
      return <AddAccountTypeModal {...modalProps} />;
    case "show-system-notification":
      return <ShowSystemNotification {...modalProps} />;
    case "import-excel":
      return <ImportExcelModal {...modalProps} />;
  }
  return null;
};

const ModalMainContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
}));

const ModalIcon = styled("span")(({ theme }) => ({
  display: "flex",
  width: "15px",
  height: "15px",
  position: "absolute",
  left: "20px",
  top: "17px",
  cursor: "pointer",
}));

export const ModalCloseButton = () => {
  const dispatch = useDispatch();
  return (
    //@ts-ignore
    <IconButton onClick={() => dispatch(appCloseModal())}>
      <CloseIcon />
    </IconButton>
  );
};

// TODO: this code needs to be refactored
const ModalContainer = (props) => {
  const { show, modalProps } = props;
  const { component, title, closButton, maxWidth } = modalProps;
  const dispatch = useDispatch();
  // const widthStyle = { width: '80vw' }
  const widthStyle = {};
  if (["add-account", "add-widget", "change-password"].includes(component)) {
    widthStyle.maxWidth = "600px";
  }
  if (maxWidth) {
    widthStyle.maxWidth = maxWidth;
  }
  return (
    <div className={`modal fade ${show ? "show d-block" : ""}`}>
      <div
        className={"position-absolute top-0 w-100 h-100"}
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        onClick={() => dispatch(appCloseModal())}
      />
      <div style={widthStyle} className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div style={{ padding: component === "add-account" ? "0" : "unset" }} className="modal-body row">
            <ModalMainContainer>
              {title && <BoxUpper title={title} Option={ModalCloseButton} />}
              <ModalIcon>
                <AiOutlineClose onClick={() => dispatch(appCloseModal())} />
              </ModalIcon>
              {props.children}
            </ModalMainContainer>
          </div>
        </div>
      </div>
    </div>
  );
};
